import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('SCHEMA_ERRORS.DENOMINATION_NAME_REQUIRED')
});
